export const rentRollSortByGroupingOptions = [
    {
        value: 'leasable_space_code',
        label: 'Units',
    },
    {
        value: 'source_system_lease_code',
        label: 'Lease Code',
    },
    {
        value: 'tenant_name',
        label: 'Tenants',
    },
    {
        value: 'lease_term_months',
        label: 'Term (Months)',
    },
    {
        value: 'remaining_months',
        label: 'Mos. Remaining',
    },
    {
        value: 'total_monthly',
        label: 'Monthly',
    },
    {
        value: 'total_annual',
        label: 'Annual',
    },
    {
        value: 'rentable_sq_ft',
        label: 'Rentable SF',
    },
    {
        value: 'total_monthly_per_sq_ft',
        label: 'Monthly / SF',
    },
    {
        value: 'total_annual_per_sq_ft',
        label: 'Annual / SF',
    },
];

export const customSummaryDataFields = [
    'total_property_name',
    'total_tenants',
    'total_leases',
    'total_units',
    'total_rent_monthly',
    'group_source_system_lease_code',
    'group_tenants',
    'group_properties',
];

export const customCalculationFields = [
    'total_cam_annual_per_sq_ft',
    'total_cam_monthly_per_sq_ft',
    'total_taxes_insurance_monthly_per_sq_ft',
    'total_taxes_insurance_annual_per_sq_ft',
    'total_other_monthly_per_sq_ft',
    'total_other_annual_per_sq_ft',
    'total_rent_annual_per_sq_ft',
    'total_rent_monthly_per_sq_ft',
    'total_monthly_per_sq_ft',
    'total_annual_per_sq_ft',
    'group_cam_annual_per_sq_ft',
    'group_cam_monthly_per_sq_ft',
    'group_taxes_insurance_monthly_per_sq_ft',
    'group_taxes_insurance_annual_per_sq_ft',
    'group_other_monthly_per_sq_ft',
    'group_other_annual_per_sq_ft',
    'group_rent_annual_per_sq_ft',
    'group_rent_monthly_per_sq_ft',
    'group_monthly_per_sq_ft',
    'group_annual_per_sq_ft',
];

export const recurringChargeBuckets = [
    'cam',
    'taxes_insurance',
    'rent',
    'other',
];

export enum RentRollColumnSelection {
    ConsolidatedCharges = 'consolidatedCharges',
    ChargeGroup = 'chargeGroup',
}

export const RENT_ROLL_DEFAULT_COLUMN_SELECTION =
    RentRollColumnSelection.ConsolidatedCharges;

export const rentRollDefaultConfigs = [
    {
        label: 'Consolidated Charges',
        key: RentRollColumnSelection.ConsolidatedCharges,
    },
    {
        label: 'By Charge Category',
        key: RentRollColumnSelection.ChargeGroup,
    },
];
